module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add"
  }, [_c('Heading', [_vm._v("Добавляем новое достижение")]), _c('Form', {
    attrs: {
      "grid": true,
      "inner": true
    }
  }, [_c('InputFile', {
    staticClass: "add__file",
    attrs: {
      "label": "Приложите файл наградного документа",
      "text": "Файл jpeg, png, gif, pdf",
      "fileName": _vm.progressForm.confirmation_file.name,
      "warnings": _vm.fileWarnings,
      "error-text": "Приложите файл наградного документа",
      "v": _vm.$v.progressForm.confirmation_file.name,
      "required": true
    },
    on: {
      "changeInput": _vm.inputFile
    }
  }), _c('Select', {
    attrs: {
      "name": "municipality",
      "label": "Муниципальное образование",
      "placeholder": "Муниципальное образование",
      "v": _vm.$v.progressForm.municipality,
      "required": true,
      "options": _vm.municipalities
    },
    model: {
      value: (_vm.progressForm.municipality),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "municipality", $$v)
      },
      expression: "progressForm.municipality"
    }
  }), _c('Select', {
    attrs: {
      "name": "mentor_id",
      "label": "Какой педагог повлиял на результат?",
      "placeholder": "Введите фамилию...",
      "filterable": true,
      "options": _vm.mentors,
      "multiple": true,
      "filterText": _vm.mentorFilterText,
      "asyncSearch": true,
      "resetFilter": true,
      "clearable": true
    },
    on: {
      "filter": _vm.inputMentor
    },
    model: {
      value: (_vm.progressForm.mentor_id),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "mentor_id", $$v)
      },
      expression: "progressForm.mentor_id"
    }
  }), _c('Select', {
    attrs: {
      "name": "partner_id",
      "label": "Какая образовательная организация повлияла на результат?",
      "placeholder": "Выберите организацию",
      "filterable": "auto",
      "emptyText": "Организация не зарегистрирована",
      "clearable": true,
      "options": _vm.organizators
    },
    model: {
      value: (_vm.progressForm.partner_id),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "partner_id", $$v)
      },
      expression: "progressForm.partner_id"
    }
  }), _c('Select', {
    attrs: {
      "name": "event_id",
      "label": "Какая образовательная программа повлияла на результат?",
      "placeholder": "Выберите программу",
      "clearable": true,
      "options": _vm.eventTypes
    },
    model: {
      value: (_vm.progressForm.event_id),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "event_id", $$v)
      },
      expression: "progressForm.event_id"
    }
  }), _c('Select', {
    attrs: {
      "name": "level",
      "label": "Уровень конкурса",
      "placeholder": "Выберите уровень",
      "clearable": true,
      "options": _vm.competitionLevel
    },
    model: {
      value: (_vm.progressForm.level),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "level", $$v)
      },
      expression: "progressForm.level"
    }
  }), _c('Select', {
    attrs: {
      "name": "competition_id",
      "label": "Конкурс",
      "placeholder": "Выберите конкурс",
      "filterable": "auto",
      "addText": "+ Добавить конкурс",
      "error-text": "Выберите конкурс",
      "options": _vm.competition,
      "v": _vm.$v.progressForm.competition_id,
      "required": true
    },
    on: {
      "add": function($event) {
        return _vm.$emit('form', 'competition')
      }
    },
    model: {
      value: (_vm.progressForm.competition_id),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "competition_id", $$v)
      },
      expression: "progressForm.competition_id"
    }
  }), _c('Datepicker', {
    attrs: {
      "label": "Дата Награждения",
      "error-text": "Выберите дату награждения",
      "value": _vm.progressForm.date_finish,
      "v": _vm.$v.progressForm.date_finish,
      "required": true
    },
    model: {
      value: (_vm.progressForm.date_finish),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "date_finish", $$v)
      },
      expression: "progressForm.date_finish"
    }
  }), _c('Select', {
    attrs: {
      "name": "result",
      "label": "Результат",
      "placeholder": "Результат",
      "error-text": "Выберите результат",
      "options": _vm.progressResult,
      "v": _vm.$v.progressForm.result,
      "required": true
    },
    model: {
      value: (_vm.progressForm.result),
      callback: function($$v) {
        _vm.$set(_vm.progressForm, "result", $$v)
      },
      expression: "progressForm.result"
    }
  }), _c('Button', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submitProgressForm
    }
  }, [_vm._v("Сохранить достижение")]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('form', 'progress')
      }
    }
  }, [_vm._v("Отмена")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd70089","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/forms/resultform/AddResult.vue
// module id = 9f84d0f52a67c054ef57
// module chunks = 46